import {kHomeTexts} from "../../../constants/texts";
import {aboutScreenHighlightWords} from "../../../helpers/StringHelper";

export default function HomeMissionTexts() {
    // Used in HomeMission to display section texts

    // BUILD
    return (
        <div className={"flex flex-col space-y-[24px] justify-start items-start"}>
            <span className={"text-[36px] font-bold text-white leading-none"}>
                {kHomeTexts.missionTitle}
            </span>
            <span className={"font-normal text-[16px] text-greyLight9"}>
                {aboutScreenHighlightWords(kHomeTexts.missionContent, ['réussisse scolairement', 'maitrise', 'savoir-faire', 'fondamentaux'])}
            </span>
        </div>
    );
}